import { render, staticRenderFns } from "./client-dialog-common-tab.vue?vue&type=template&id=c7ec56c2&scoped=true"
import script from "./client-dialog-common-tab.vue?vue&type=script&lang=js"
export * from "./client-dialog-common-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ec56c2",
  null
  
)

export default component.exports